import request from '@/utils/request'


export function addRequest(data) {
  return request({
    url: '/db/menu',
    method: 'put',
    data
  })
}

export function deleteRequest(id) {
  return request({
    url: `/db/menu/${id}`,
    method: 'delete'
  })
}

export function updateRequest(data) {
  return request({
    url: '/db/menu',
    method: 'post',
    data
  })
}

export function queryRequest(data) {
  return request({
    url: '/db/menu/query',
    method: 'post',
    data
  })
}

